import React from 'react';
import { Link } from 'react-router-dom';
import { EditorialNav, EditorialFooter } from './landing/EditorialShell';
import EditorialArticle from './landing/EditorialArticle';
import '../assets/scss/landing-v2.scss';

const RefundPage: React.FC = () => (
    <div
        className="lp2"
        style={{
            background: '#0a0a0a',
            color: '#f4f2ee',
            fontFamily: "'Geist', -apple-system, BlinkMacSystemFont, sans-serif",
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
        }}
    >
        <EditorialNav />
        <main style={{ flex: 1 }}>
            <EditorialArticle eyebrow="LEGAL" title="Refund Policy" subtitle="Effective date: April 27, 2026">
                <h2>1. How to get a refund</h2>
                <p>
                    To get your money back, send an email to <strong>support@doyourstep.com</strong> from the
                    address you used at checkout. Include your Polar order number if you have it - you will
                    find it in your receipt email.
                </p>
                <p>
                    You do not need to explain why. Once we confirm your request,{' '}
                    <strong>Polar Software Inc.</strong>, our payment provider, returns the full amount to your
                    original payment method within <strong>5-10 business days</strong>. We aim to confirm we
                    received your request within one business day.
                </p>

                <h2>2. Cancelling your subscription</h2>
                <p>
                    Cancelling is different from a refund: it stops all future charges going forward, while a
                    refund returns money you have already paid.
                </p>
                <p>
                    You can cancel anytime yourself in the{' '}
                    <a
                        href="https://polar.sh/doyourstepcom/portal"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Polar customer portal
                    </a>
                    . Sign in with the email you used at checkout, open your subscription, and cancel in one
                    click. If you have any trouble, email <strong>support@doyourstep.com</strong> and we will
                    cancel it for you. After cancelling, you keep access until the end of the period you have
                    already paid for.
                </p>

                <h2>3. 30-day no-questions-asked guarantee</h2>
                <p>
                    We stand behind the Service. If for any reason you are unsatisfied with your purchase, you
                    may request a <strong>full refund within 30 calendar days</strong> from the date of
                    purchase, no explanation required.
                </p>
                <p>
                    To request a refund, send an email to <strong>support@doyourstep.com</strong> from the
                    address used at checkout. Include the order number from your Polar invoice if available.
                    We aim to confirm receipt within one business day.
                </p>

                <h2>4. After 30 days</h2>
                <p>
                    Refund requests made <strong>after the 30-day window</strong> will not be accepted. The
                    purchase becomes final and non-refundable. This includes situations where you have not
                    used the Service or where you wish to switch plans.
                </p>

                <h2>5. How refunds are processed</h2>
                <p>
                    All payments and refunds are handled by <strong>Polar Software Inc.</strong> as our
                    Merchant of Record. Once we approve a refund request, Polar returns the full amount to
                    the original payment method within 5-10 business days. The exact timing depends on your
                    bank or card issuer.
                </p>
                <p>
                    Polar may issue refund confirmations directly to the email address used at checkout.
                </p>

                <h2>6. Abuse and fraud</h2>
                <p>
                    We reserve the right to deny refund requests where we detect, in good faith:
                </p>
                <ul>
                    <li>Repeated purchase-and-refund cycles by the same user or payment method</li>
                    <li>Fraudulent purchases or stolen-card transactions</li>
                    <li>
                        Use of the Service in violation of our{' '}
                        <Link to="/terms">Terms of Use</Link> (e.g. scraping, reselling, automated abuse)
                    </li>
                    <li>Refund requests submitted after the 30-day window</li>
                </ul>

                <h2>7. Chargebacks</h2>
                <p>
                    Please contact us at support@doyourstep.com before initiating a chargeback with your
                    bank or card issuer. We will work with you in good faith to resolve any issue. Initiating
                    an unjustified chargeback while the Service was provided as described may result in
                    suspension of your account.
                </p>

                <h2>8. Limitation of liability</h2>
                <p>
                    Refunds are limited to the amount actually paid to us for the Service that gave rise to
                    the request. We do not refund consequential, indirect, or incidental losses (including but
                    not limited to lost time, lost productivity, or any decisions you made based on the
                    diagnostic content). For full liability disclaimers, see the{' '}
                    <Link to="/terms">Terms of Use</Link>.
                </p>

                <h2>9. Changes to this policy</h2>
                <p>
                    We may update this Refund Policy from time to time. Any change will be reflected on this
                    page along with a new effective date. The policy in force at the time of your purchase
                    governs that purchase.
                </p>

                <h2>10. Contact</h2>
                <p>
                    All refund requests and questions: <strong>support@doyourstep.com</strong>
                </p>
                <p>
                    For questions about Polar&apos;s payment handling, see{' '}
                    <a
                        href="https://polar.sh/legal/terms"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Polar&apos;s Terms of Service
                    </a>
                    .
                </p>
            </EditorialArticle>
        </main>
        <EditorialFooter />
    </div>
);

export default RefundPage;
